import{m as e}from"./chunk-HBP5N4FR.js";e();var s=`.dapp-core-component__styles__scResultHash .dapp-core-component__styles__hash {
  font-size: 1rem;
  align-items: flex-end;
  max-width: none;
}
.dapp-core-component__styles__scResultHash .dapp-core-component__styles__hash [class*=left] span,
.dapp-core-component__styles__scResultHash .dapp-core-component__styles__hash [class*=right] span {
  font-size: 1rem;
}
.dapp-core-component__styles__scResultHash .dapp-core-component__styles__copy {
  margin-left: 0.5rem;
}
.dapp-core-component__styles__scResultHash .dapp-core-component__styles__copy svg path {
  fill: #cacbcc;
  transition: all 200ms;
}
.dapp-core-component__styles__scResultHash .dapp-core-component__styles__copy svg path:hover {
  fill: #1f43f4;
}
.dapp-core-component__styles__scResultHash .dapp-core-component__styles__explorer {
  color: #cacbcc;
  transition: all 200ms;
}
.dapp-core-component__styles__scResultHash .dapp-core-component__styles__explorer:hover {
  color: #1f43f4;
  text-decoration: none;
}`;document.head.appendChild(document.createElement("style")).appendChild(document.createTextNode(s));var t={scResultHash:"dapp-core-component__styles__scResultHash",hash:"dapp-core-component__styles__hash",copy:"dapp-core-component__styles__copy",explorer:"dapp-core-component__styles__explorer"};export{s as a,t as b};
//# sourceMappingURL=chunk-AZB2QFQE.js.map
